"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _uiLibrary = require("@sm360/ui-library");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var range = function range(start, end, desc) {
  var ans = [];

  if (desc) {
    for (var i = end; i >= start; i -= 1) {
      ans.push(i);
    }
  } else {
    for (var _i = start; _i <= end; _i += 1) {
      ans.push(_i);
    }
  }

  return ans;
};

var monthsEn = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
var monthsFr = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'];

var initializeMonth = function initializeMonth(date, minDate, maxDate) {
  if (date && date.getMonth() >= 0) return date.getMonth();
  if (minDate && minDate.getMonth() >= 0) return minDate.getMonth();
  if (maxDate && maxDate.getMonth() >= 0) return maxDate.getMonth();
  return new Date().getMonth();
};

var initializeYear = function initializeYear(date, minDate, maxDate) {
  if (date) return date.getFullYear();
  if (minDate) return minDate.getFullYear();
  if (maxDate) return maxDate.getFullYear();
  return new Date().getFullYear();
};

var initializeMinYear = function initializeMinYear(minDate, date) {
  var min = minDate && minDate.getFullYear();
  var pickedYear = date && date.getFullYear();

  if (min) {
    // In case prop minDate is badly set
    if (pickedYear && pickedYear < min) return pickedYear - 30;
    return min;
  }

  if (pickedYear) {
    if (pickedYear > new Date().getFullYear()) return new Date().getFullYear() - 30;
    return pickedYear - 30;
  }

  return new Date().getFullYear() - 30;
};

var initializeMaxYear = function initializeMaxYear(maxDate, date) {
  var max = maxDate && maxDate.getFullYear();
  var pickedYear = date && date.getFullYear();

  if (max) {
    // In case prop maxDate is badly set
    if (pickedYear && pickedYear > max) return pickedYear + 30;
    return max;
  }

  if (pickedYear) {
    if (pickedYear < new Date().getFullYear()) return new Date().getFullYear() + 30;
    return pickedYear + 30;
  }

  return new Date().getFullYear() + 30;
};

var getYearOptions = function getYearOptions(minYear, maxYear, isYearSelectorDesc) {
  var years = range(minYear, maxYear, isYearSelectorDesc);
  var options = [];
  years.forEach(function (item) {
    return options.push({
      value: item,
      id: "year-" + item,
      label: item
    });
  });
  return options;
};

var getMonthOptions = function getMonthOptions(isLangFrench) {
  var months = range(0, 11);
  var options = [];
  months.forEach(function (item) {
    return options.push({
      value: monthsEn[item],
      id: monthsEn[item],
      label: isLangFrench ? monthsFr[item] : monthsEn[item]
    });
  });
  return options;
};

var InputDateHeader = function InputDateHeader(props) {
  var date = props.date,
      changeYear = props.changeYear,
      changeMonth = props.changeMonth,
      decreaseMonth = props.decreaseMonth,
      increaseMonth = props.increaseMonth,
      prevMonthButtonDisabled = props.prevMonthButtonDisabled,
      nextMonthButtonDisabled = props.nextMonthButtonDisabled,
      lang = props.lang,
      minDate = props.minDate,
      maxDate = props.maxDate,
      isYearSelectorDesc = props.isYearSelectorDesc,
      title = props.title;
  var isLangFrench = lang && (lang.search('fr') !== -1 || lang.search('FR') !== -1);
  var minYear = initializeMinYear(minDate, date);
  var maxYear = initializeMaxYear(maxDate, date);
  var yearOptions = getYearOptions(minYear, maxYear, isYearSelectorDesc);
  var monthOptions = getMonthOptions(isLangFrench);
  var year = initializeYear(date, minDate, maxDate);
  var month = initializeMonth(date, minDate, maxDate);

  var onChangeMonth = function onChangeMonth(value) {
    var index = monthsEn.indexOf(value);
    if (index !== -1) changeMonth(index);
  };

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, title && title.length && /*#__PURE__*/_react.default.createElement("div", {
    className: "input-date-header-title"
  }, title), /*#__PURE__*/_react.default.createElement("div", {
    className: "grid-x align-center"
  }, /*#__PURE__*/_react.default.createElement(_uiLibrary.Select, {
    className: "cell shrink",
    value: year,
    onChange: changeYear,
    options: yearOptions
  }), /*#__PURE__*/_react.default.createElement(_uiLibrary.Button, {
    className: "cell small-1 padding-left-1",
    onClick: decreaseMonth,
    disabled: prevMonthButtonDisabled || year === minYear && month === 0,
    icon: "angle-left",
    color: "secondary",
    displayAsLink: true,
    "aria-label": "Previous month"
  }), /*#__PURE__*/_react.default.createElement(_uiLibrary.Select, {
    className: "cell small-5",
    value: monthsEn[month],
    onChange: onChangeMonth,
    options: monthOptions
  }), /*#__PURE__*/_react.default.createElement(_uiLibrary.Button, {
    className: "cell small-1",
    onClick: increaseMonth,
    disabled: nextMonthButtonDisabled || year === maxYear && month === 11,
    icon: "angle-right",
    color: "secondary",
    displayAsLink: true,
    "aria-label": "Next month"
  })));
};

InputDateHeader.propTypes = {
  date: _propTypes.default.instanceOf(Date),
  changeYear: _propTypes.default.func,
  changeMonth: _propTypes.default.func,
  decreaseMonth: _propTypes.default.func,
  increaseMonth: _propTypes.default.func,
  prevMonthButtonDisabled: _propTypes.default.bool,
  nextMonthButtonDisabled: _propTypes.default.bool,
  lang: _propTypes.default.string,
  minDate: _propTypes.default.instanceOf(Date),
  maxDate: _propTypes.default.instanceOf(Date),
  isYearSelectorDesc: _propTypes.default.bool,
  isMonthSelectorDesc: _propTypes.default.bool,
  title: _propTypes.default.string
};
var _default = InputDateHeader;
exports.default = _default;